import { useState, useEffect, useCallback } from 'react';
import { ApiError } from '../types';
import { userService, organizationService, teamService, subscriptionService, paymentService, invitationService, roleService, contentService, tagService, searchService, authService } from '../../services';
import { extractErrorMessage } from '../utils/error-handler';

export function useTeamRoles(teamId: string) {
  const [roles, setRoles] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<ApiError | null>(null);
  
  const fetchRoles = useCallback(async () => {
    if (!teamId) return;
    
    setIsLoading(true);
    setError(null);
    
    try {
      console.log(`Fetching roles for team: ${teamId}`);
      const teamRoles = await teamService.getTeamRoles(teamId, true);
      setRoles(teamRoles);
    } catch (err) {
      console.error('Error fetching team roles:', err);
      setError(extractErrorMessage(err));
    } finally {
      setIsLoading(false);
    }
  }, [teamId]);
  
  useEffect(() => {
    fetchRoles();
  }, [fetchRoles]);
  
  return {
    roles,
    isLoading,
    error,
    refreshRoles: fetchRoles
  };
}

export default useTeamRoles;